/* eslint-disable no-console */
import axios from "axios";
import head from "lodash/head";
import isObject from "lodash/isObject";
import Swal from "sweetalert2";
import clone from "lodash/clone";
import { RESPONSE_ACCEPTS, STATUS_CODES } from "../config/constants";

const API_URL =
  process.env.NODE_ENV === "test"
    ? process.env.BASE_URL || `http://localhost:${process.env.PORT}/api/`
    : `/api/`;

const Http = axios.create({
  baseURL: API_URL,
  headers: {
    "X-CSRF-TOKEN": window.Laravel.csrfToken,
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

Http.interceptors.response.use(
  (response) => {
    if (!response.data.success) {
      let message = "Have an error.";
      const hasCheckDuplicateDate = response.data?.error_messages?.check_duplicate_date ?? false;
      if (isObject(response.data.error_messages)) {
        message = head(Object.values(response.data.error_messages));
      } else {
        message = response.data.error_messages;
      }
      if (!(message === "not_release_yet" || hasCheckDuplicateDate)) {
        Swal.fire({
          title: null,
          html: message,
          icon: "error",
        });
      }
      const newResponse = clone(response);
      newResponse.data.error_messages = message;
      hasCheckDuplicateDate ? (newResponse.data.is_duplicate_date = true) : null;
      return newResponse;
    }

    return response.data;
  },
  (error) => {
    if (error.response.status === STATUS_CODES.HTTP_SERVICE_UNAVAILABLE) {
      window.location.href = "/";
      return null;
    }
    if (!RESPONSE_ACCEPTS.ERRORS.includes(error.code)) {
      Swal.fire({
        title: null,
        html: error?.message || "Server error.",
        icon: "error",
      });
    }

    return Promise.reject(error);
  }
);

export default Http;
